import React, { useEffect, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../constants/Context";
import { logPlayCricketResponse } from "../utils/playCricketLogger";
const PlayersAPI = ({ clubId, onDataLoaded, onError, onLoading }) => {
  const { API_TOKEN } = useContext(GlobalContext);

  useEffect(() => {
    if (!clubId) return;

    const fetchPlayers = async () => {
      const url = `https://www.play-cricket.com/api/v2/sites/${clubId}/players?&api_token=${API_TOKEN}`;
      try {
        onLoading(true);
        const response = await axios.get(url);
        logPlayCricketResponse({
          endpoint: "players",
          requestUrl: url,
          httpStatus: response.status,
          isSuccess: true,
          rawResponse: response.data,
        });
        const playersData = response.data.players || [];
        onDataLoaded(playersData);
        onLoading(false);
      } catch (err) {
        logPlayCricketResponse({
          endpoint: "players",
          requestUrl: url,
          httpStatus: err.response?.status || null,
          isSuccess: false,
          rawResponse: err.response?.data || null,
          errorMessage: err.message,
        });
        onError(err.message);
        onLoading(false);
      }
    };

    fetchPlayers();
  }, [clubId]);

  return null;
};

export default PlayersAPI;